/* eslint-disable @typescript-eslint/no-unused-vars */
import i18nInst from 'src/i18n';
import {
  DlpPolicyItem,
  ShareLinkFilter,
  Notification,
  TargetCapacity,
  TargetUser,
  TargetGroup,
  DlpPolicyFilters,
} from '@Policy/utils/types';
import { Key } from 'react';
import { TreeNode } from '@Components/Tree/type';
import cloneDeep from 'lodash/cloneDeep';

import {
  FilterValidator,
  findNodeByKey,
  removeElements,
  uniqueArr,
} from '@Policy/utils/fns';
import { getAllKeys } from '@Components/Tree/utils';
import { policyTargetsInlineSelector } from '../general/store';
import { getEmptyTargetUserGroup } from '@Policy/TemplateConfig/cfg.default';

export const createShareLinkFilterSlice = (
  setPolicy: any,
  getPolicy: any,
  getAll: any
) => {
  const { t } = i18nInst;
  return {
    setSlfState: (payload: Partial<ShareLinkFilter>) => {
      setPolicy((state: DlpPolicyItem) => ({
        ...state,
        tmSlfFilters: {
          ...state.tmSlfFilters,
          ...payload,
        },
      }));
    },
    setSlfNtfState: (payload: Partial<Notification>) => {
      setPolicy((state: DlpPolicyItem) => ({
        ...state,
        tmSlfFilters: {
          ...state.tmSlfFilters,
          notification: {
            ...(state.tmSlfFilters?.notification || {}),
            ...payload,
          },
        },
      }));
    },
    setException: (index: number) => {
      const store = getAll();
      const emptyTargetUserGroup = getEmptyTargetUserGroup();
      const {
        tempVars: {
          slfExceptionPaths = [],
          targetUserGroups = emptyTargetUserGroup,
        } = {},
      } = store;
      if (index === -1) {
        setPolicy((state: DlpPolicyItem) => {
          state.tmSlfFilters?.slfExceptionList.push({
            slfExceptionPaths,
            slfExceptionUsers: targetUserGroups,
          });
        });
      } else {
        if (
          index >= (getPolicy().tmSlfFilters?.slfExceptionList || []).length
        ) {
          return;
        }
        setPolicy((state: DlpPolicyItem) => {
          state.tmSlfFilters?.slfExceptionList.splice(index, 1, {
            slfExceptionPaths,
            slfExceptionUsers: targetUserGroups,
          });
        });
      }
    },
    deleteException: (index: number) => {
      const policy = getPolicy();
      const { slfExceptionList = [] } = policy.tmSlfFilters || {};
      if (index < 0 || index >= slfExceptionList.length) {
        return;
      }
      setPolicy((state: DlpPolicyItem) => {
        state.tmSlfFilters?.slfExceptionList.splice(index, 1);
      });
    },
    setEditExceptionStatus: (index: number) => {
      const policy = getPolicy();
      const store = getAll();
      const { slfExceptionList = [] } = policy.tmSlfFilters || {};
      const { setTempVars } = store;
      const exception = slfExceptionList[index];
      setTempVars({
        slfExceptionPaths: exception.slfExceptionPaths,
        targetUserGroups: exception.slfExceptionUsers,
      });
    },
    addPathToExceptionPaths: (path: string) => {
      const store = getAll();
      const exceptionPaths = store.tempVars.slfExceptionPaths || [];
      const { setTempVars } = store;
      if (!path.startsWith('/')) {
        return;
      }
      if (exceptionPaths.includes(path)) {
        return;
      }
      // popup error
      if (exceptionPaths.length >= 10) {
        return;
      }
      const newExceptionPaths = uniqueArr([...exceptionPaths, path]);
      setTempVars({
        slfExceptionPaths: newExceptionPaths,
      });
    },
    removePathFromExceptionPaths: (path: string) => {
      const store = getAll();
      const exceptionPaths = [...store.tempVars.slfExceptionPaths] || [];
      const { setTempVars } = store;
      removeElements(exceptionPaths, [path]);
      setTempVars({
        slfExceptionPaths: exceptionPaths,
      });
    },
    validateShareLink: () => {
      const currentState = getPolicy();
      const filter = currentState.tmSlfFilters;
      const validator = new FilterValidator(DlpPolicyFilters.tmSlfFilters);
      validator.add(filter.notification, 'checkNotification');
      const result = validator.check();
      return result;
    },
  };
};
